(function () {
  if (window.dmReviewSliderBound) return;
  window.dmReviewSliderBound = true;

  function updateArrows(slider) {
    if (!slider) return;

    var track = slider.querySelector('[data-bts-review-track]');
    var previousButton = slider.querySelector('[data-bts-review-prev]');
    var nextButton = slider.querySelector('[data-bts-review-next]');

    if (!track || !previousButton || !nextButton) return;

    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    var hasOverflow = isMobile && maxScroll > 2;

    previousButton.hidden = !hasOverflow || track.scrollLeft <= 2;
    nextButton.hidden = !hasOverflow || track.scrollLeft >= maxScroll - 2;
  }

  function updateAllArrows() {
    document.querySelectorAll('[data-bts-review-slider]').forEach(updateArrows);
  }

  function scrollReviews(slider, direction) {
    var track = slider && slider.querySelector('[data-bts-review-track]');
    if (!track) return;

    var card = track.querySelector('.bts-review-card');
    var styles = window.getComputedStyle(track);
    var gap = Number.parseFloat(styles.columnGap || styles.gap) || 14;
    var distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.4;

    track.scrollBy({
      left: direction * distance,
      behavior: 'smooth'
    });
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var button = event.target.closest('[data-bts-review-prev], [data-bts-review-next]');
    var slider = button && button.closest('[data-bts-review-slider]');
    if (!button || !slider) return;

    scrollReviews(slider, button.hasAttribute('data-bts-review-next') ? 1 : -1);
  });

  document.addEventListener(
    'scroll',
    function (event) {
      var track = event.target;
      if (!(track instanceof Element) || !track.matches('[data-bts-review-track]')) return;

      window.requestAnimationFrame(function () {
        updateArrows(track.closest('[data-bts-review-slider]'));
      });
    },
    true
  );

  window.addEventListener('resize', updateAllArrows, { passive: true });
  document.addEventListener('shopify:section:load', updateAllArrows);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAllArrows);
  } else {
    updateAllArrows();
  }
})();
